import React, { FC, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ApplicationFeature } from "@green0meter/api-client";

import PbiReport from "@components/common/PbiReport";
import { Box, Button, Card, Typography, Stack } from "@components/base";
import { getWindowSize } from "@helpers";

interface OverviewProps {
  title: string;
  dashboardPath: string;
  viewDashboardText: string;
  reportPageId: string;
  reportId?: string;
}

const Overview: FC<OverviewProps> = ({
  title,
  dashboardPath,
  viewDashboardText,
  reportPageId,
  reportId,
}) => {
  const [windowSize, setWindowSize] = useState(getWindowSize());
  const navigate = useNavigate();

  useEffect(() => {
    const handleWindowResize = (): void => {
      setWindowSize(getWindowSize());
    };

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  return (
    <Card>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        p={3}
      >
        <Typography variant="subtitle1">{title}</Typography>
        <Button
          variant="outlined"
          size="small"
          onClick={() => navigate(dashboardPath)}
        >
          {viewDashboardText}
        </Button>
      </Stack>
      <Box sx={{ height: windowSize.innerWidth * 0.28, overflow: "hidden" }}>
        <PbiReport
          bg={"default"}
          pageId={reportPageId}
          height={windowSize.innerWidth * 0.3}
          extraFilters={[]}
          reportId={reportId}
          reportType={ApplicationFeature.VSME}
        />
      </Box>
    </Card>
  );
};

export default Overview;
